import React from 'react';
import { motion } from 'framer-motion';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  id?: string;
  align?: 'center' | 'left';
  /** Word inside the title to render in the rose→violet gradient. */
  accent?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  id,
  align = 'center',
  accent
}: SectionHeadingProps) {
  const centered = align === 'center';
  const [before, after] = accent ? title.split(accent) : [title, ''];
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={centered ? 'text-center' : 'text-left'} data-id="element-117" data-mp="gjq09s9fm9g3">
      {eyebrow && <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-lotus-400" data-id="element-118" data-mp="ujhiy6aw8e0f">
          {eyebrow}
        </p>}
      <h2 id={id} className="mt-4 font-display text-4xl font-light tracking-wide text-white sm:text-5xl" data-id="element-119" data-mp="zazkavgtwglx">
        {accent ? <>
            {before}
            <em className="text-neon italic" data-id="element-120" data-mp="1obnpvkuvo61u">{accent}</em>
            {after}
          </> : title}
      </h2>
      <div className={`rule-gold mt-6 w-28 ${centered ? 'mx-auto' : ''}`} data-id="element-121" data-mp="2313dirz43vdb" />
      {subtitle && <p className={`mt-6 text-[15px] font-light leading-relaxed text-neutral-300 ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-122" data-mp="1y7r1dhbmdh1g">
          {subtitle}
        </p>}
    </motion.div>;
}